// hooks/useToken.ts
import { jwtDecode } from 'jwt-decode';
import { useState, useEffect } from 'react';
import { resetCurrentUser } from '../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store/store';

interface DecodedToken {
  customerId: string;
  createdAt: string;
  exp: number;
  iat: number;
  id: number;
  userId: string;
  email: string;
  joiningStatus: string;
  teamRole: string;
  firstName: string;
  lastName: string;
  role: string;
  organization: {
    id: number;
    name: string;
    customerId: string;
    type: string;
    discoverySource: string;
  };
  // Any other fields present in your JWT token
}

const useToken = () => {
  const dispatch: AppDispatch = useDispatch();

  const [decodedToken, setDecodedToken] = useState<DecodedToken | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const tokenString = localStorage.getItem('token');

  useEffect(() => {
    if (tokenString) {
      try {
        const decoded: DecodedToken = jwtDecode(tokenString);
        const isTokenExpired = decoded.exp * 1000 < Date.now();

        const isJoinedOrganization = decoded.joiningStatus === 'joined' || decoded.teamRole;

        if (!isTokenExpired && isJoinedOrganization) {
          setDecodedToken(decoded);
        } else {
          console.warn('Token has expired');
          localStorage.removeItem('token');
        }
      } catch (error) {
        console.error('Failed to parse or decode token:', error);
        localStorage.removeItem('token');
        dispatch(resetCurrentUser());
      }
    }
    setLoading(false);
  }, []);

  return { decodedToken, loading, tokenString };
};

export default useToken;
